const ZDANIA36 = [
  {
    name: "[6 klasa] Mod 5. Kap 6.",
    lang: 'de',
    zdania: [
      {
        pl: "poczta",
        de: "die Post",
      },
      {
        pl: "kościół",
        de: "die Kirche",
      },
      {
        pl: "ratusz",
        de: "die Rathaus",
      },
      {
        pl: "skrzyżowanie",
        de: "die Kreuzung",
      },
      {
        pl: "światła",
        de: "die Ampel",
      },
      {
        pl: "pasy  dla pieszych",
        de: "der Zebrastreifen",
      },
      {
        pl: "stacja benzynowa",
        de: "die Tankstelle",
      },
      {
        pl: "parking",
        de: "der Parkplatz",
      },
      {
        pl: "plan miasta",
        de: "der Stadtplan",
      },
      {
        pl: "ulica",
        de: "die Straße",
      },
      {
        pl: "chodnik",
        de: "der Gehweg",
      },
      {
        pl: "Muszę iśc na pocztę",
        de: "Ich muss zur Post gehen",
      },
      {
        pl: "Oni zawsze w niedzielę chodzą do kościoła",
        de: "Sie gehen immer am Sonntag in die Kirche",
      },
      {
        pl: "Chemy zwiedzi jutro stare ratusz",
        de: "Wir wollen morgen das alte Rathaus besichtigen",
      },
      {
        pl: "Na skrzyżowaniu jedziemy w lewo",
        de: "An der Kreuzung fahren wir nach links",
      },
      {
        pl: "Zatrzymaj się na światłach!",
        de: "Bleib an der Ampel stehen!",
      },
      {
        pl: "Samochód musi zatrzymać się na pasach dla pieszych",
        de: "Ein Fahrzeug muss an der Zebrastreifen stoppen",
      },
      {
        pl: "Jadę teraz na stację benzynową",
        de: "ich fahre jetzt zur Tankstelle",
      },
      {
        pl: "Na parkingu już nie ma miejsca",
        de: "Auf dem Parkplatz gibt es keinen Platz mehr",
      },
      {
        pl: "Kupiłeś plan miasta Monachium?",
        de: "Hast du einen Stadtplan von München gekauft?",
      },
      {
        pl: "Mieszkam przy ulicy Paryskiej",
        de: "Ich wohne in der Pariser Straße",
      },
      {
        pl: "Robią tu nowy chodnik",
        de: "Sie machen hier einen neuen Gehweg",
      },
      {
        pl: "warzywniak (sklep z warzywami)",
        de: "das Gemüsegeschäft",
      },
      {
        pl: "Sklep ekoloiczny (ze zdrową żywnością - organiczny)",
        de: "das Bioladen",
      },
      {
        pl: "piekarnia",
        de: "die Bäckerei",
      },
      {
        pl: "Butik z odzieżą",
        de: "Kleiderboutique",
      },
      {
        pl: "cenrum handlowe",
        de: "das Kaufhaus",
      },
      {
        pl: "Supermarket",
        de: "der Supermarkt",
      },
      {
        pl: "księgarnia",
        de: "die Buchhandlung",
      },
      {
        pl: "sklep rzeźniczy / sklep mięsny",
        de: "die Metzgerei",
      },
      {
        pl: "Chleb kupuję w piekarni",
        de: "Brot kaufe ich in der Bäckerei",
      },
      {
        pl: "Banany kupuję w warzywniaku",
        de: "Banane kaufe ich in der Gemüsegeschäft",
      },
      {
        pl: "Kiełbaski kupuję w sklepie mięsnym",
        de: "Würstchen kaufe ich in der Metzgerei",
      },
      {
        pl: "Ciasto kupuję w pekarni",
        de: "Kuchen kaufe ich in der Bäckerei",
      },
      {
        pl: "Buty kupuję w butiku z odzieżą",
        de: "Schuhe kaufe ich in der Kleiderboutique",
      },
      {
        pl: "Szynkę kupuję w sklepie mięsnym",
        de: "Schinken kaufe ich in der Metzgerei",
      },
      {
        pl: "Sałatę kupuję w sklepie z warzywami",
        de: "Salat kaufe ich in der Gemüsegeschäft",
      },
      {
        pl: "Jajka kupuję w sklpe z żywnością ekologiczną",
        de: "Eier kaufe ich in der Bioladen",
      },
      {
        pl: "Ser kupuję w supermarkecie",
        de: "Käse kaufe ich im Supermarkt",
      },
      {
        pl: "Ubrań kupuję w centrum handlowym",
        de: "Kleider kaufe ich im Kaufhaus",
      },
      {
        pl: "Gdzie kupuje się lekarstwa?",
        de: "Wo kauft man die Medikamente?",
      },
      {
        pl: "Leki kupuje się w aptece",
        de: "Medikamente kaufen Sie in der Apotheke",
      },
      {
        pl: "Gdzie kupuje się pocztówki?",
        de: "Wo kauft man die Postkarten?",
      },
      {
        pl: "Pocztówki kupuję na poczcie",
        de: "Postkarten kaufe ich auf der Post",
      },
      {
        pl: "gdzie kupuje się chleb?",
        de: "Wo kauft man Brot?",
      },
      {
        pl: "Pani Malin, gdzie kupuje Pani zwykle?",
        de: "Frau Malin, wo kaufen Sie normalerweise ein?",
      },
      {
        pl: "Warszywa i owoce kupuje na targu",
        de: "Gemüse und Obst kaufe ich auf dem Markt",
      },
      {
        pl: "Zawsze wiem skąd pochodzi mięso",
        de: "Ich weiß immer woher das Fleisch kommt",
      },
      {
        pl: "To bardzo ważne w dzisiejszych czasach",
        de: "Das ist heutezutage sehr wichtig",
      },
      {
        pl: "Kwiaciarnia",
        de: "die Blumenladen",
      },
      {
        pl: "Kwiaty kupuję w kwiaciarni",
        de: "Blumen kaufe ich in der Blumenladen",
      },
      {
        pl: "Gdzie kupuje się kwiaty?",
        de: "Wo kauft man Blumen?",
      },
      {
        pl: "Lody kupuję w lodziarni, a nie w supermarkecie",
        de: "Leder kaufe ich in der Lederladen, nicht im Supermarkt",
      },
      {
        pl: "Spotkajmy się w kinie",
        de: "Treffen wir uns im Kino",
      },
      {
        pl: "Spotkajmu się w parku",
        de: "Treffen wir uns im Park",
      },
      {
        pl: "Spotkamy się w Pizzerii",
        de: "Treffen wir uns in der Pizzeria",
      },
      {
        pl: "Nie w restauracji, lepiej w kawiarni",
        de: "Nicht im Restaurant, lieber im Café",
      },
      {
        pl: "Przed kinem jest Media Markt",
        de: "Vor dem Kino ist Media Markt",
      },
      {
        pl: "Przed parkiem jest stacja benzynowa",
        de: "Vor dem Park ist Tankstelle",
      },
      {
        pl: "Za hotelem jest supermarket",
        de: "Nach der Hotelschule ist Supermarkt",
      },
      {
        pl: "Obok piekarni jest sklep mięsny",
        de: "Neben der Bäckerei ist Metzgerei",
      },
      {
        pl: "Obok kwiaciarni jest sklep z odzieżą",
        de: "Neben der Blumenladen ist Kleiderboutique",
      },
      {
        pl: "Gdzie stoi Tina?",
        de: "Wo steht Tina?",
      },
      {
        pl: "Gdzie siedzi Stefan?",
        de: "Wo sitzt Stefan?",
      },
      {
        pl: "Gdzie jest Pani Malin?",
        de: "Wo ist Frau Malin?",
      },
      {
        pl: "Gdzie jest kino Astra",
        de: "Wo is das Astra Kino?",
      },
      {
        pl: "Tego nie wiem",
        de: "Das weiß ich nicht",
      },
      {
        pl: "Nie wiemy gdzie jest kawiarnia Basar",
        de: "Wir wissen nicht wo das Café Basar ist",
      },
      {
        pl: "Wiesz z pewnością gdzie jest poczta, nieprawdaż?",
        de: "Du weißt bestimmt wo die Post ist, nicht wahr?",
      },
      {
        pl: "Panie Majer wiesz Pan, gdzie jest Hotel City?",
        de: "Herr Majer, wissen Sie wo das Hotel City ist?",
      },
      {
        pl: "Gdzie jest apteka? Wisz to?",
        de: "Wo ist die Apotheke? Weißt du das?",
      },
      {
        pl: "Tina, Stefan wiecie gdzie jest kawiarnia Rose?",
        de: "Tina, Stefan, wisst ihr wo das Café Rose ist?",
      },
      {
        pl: "Gdzie jest pizzera Bella Napoli?",
        de: "Wo ist die Pizzeria Bella Napoli?",
      },
      {
        pl: "Niestety tego nie wiem, ale wiem gdzie jest pizzera Margarita",
        de: "Leider weiß ich nicht wo die Pizzeria Margarita ist",
      },
      {
        pl: "W warzywniaku można kupić warzywa i owoce",
        de: "In der Gemüsegeschäft man kann Gemüse und Obst kaufen",
      },
      {
        pl: "W Piekarńi można kupić chleb",
        de: "In der Bäckerei man kann Brot kaufen",
      },
      {
        pl: "W sklepie ekologicznym można kupić zdrową żywnośc (bioprodukty)",
        de: "In der Bioladen man kann bioproducte kaufen",
      },
      {
        pl: "W sklepie mięsnym można kupić kiełbaski",
        de: "In der Metzgerei man kann Würstchen kaufen",
      },
      {
        pl: "W sklepie z odzieżą można kupić ubrania",
        de: "In der Kleiderboutique man kann Kleider kaufen",
      },
      {
        pl: "W cukierni można kupić ciasto",
        de: "In die Kondiorei kan man Kuchen kaufen",
      },
      {
        pl: "Pani Malin zapomniała kupi cheleb w piekarni",
        de: "Frau Malin die Brot in der Bäckerei leigen lassen",
      },
      {
        pl: "Pani Malin zapomniała kupić kwiaty w kwiaciarni",
        de: "Frau Malin die Blumen in der Blumenladen leigen lassen",
      },
      {
        pl: "Pani Malin zapomniała kupić ser w supermarkecie",
        de: "Frau Malin die Käse im Supermarkt leigen lassen",
      },
    ],
  },
];

const ZDANIA37 = [
  {
    name: "[6 klasa] Mod 6. Kap 2.",
    lang: 'de',
    zdania: [
      {
        pl: "Mieszkamy w domu.",
        de: "Wir wohnen in einem Haus.",
      },
      {
        pl: "Oni mają ładne mieszkanie.",
        de: "Sie haben eine schöne Wohnung.",
      },
      {
        pl: "Szafa stoi w korytarzu.",
        de: "Der Schrank steht im Flur.",
      },
      {
        pl: "Ojciec idzie do piwnicy.",
        de: "Der Vater geht in den Keller.",
      },
      {
        pl: "Mamy ogród.",
        de: "Wir haben einen Garten.",
      },
      {
        pl: "Parkujemy w garażu.",
        de: "Wir parken in der Garage.",
      },
      {
        pl: "Na dachu siedzą ptaki.",
        de: "Auf dem Dach sitzen Vögel.",
      },
      {
        pl: "On ma pokój na poddaszu.",
        de: "Er hat ein Zimmer auf dem Dachboden.",
      },
      {
        pl: "Moje mieszkanie jest na pierwszym piętrze.",
        de: "Meine Wohnung ist im ersten Stockwerk.",
      },
      {
        pl: "Zawołam windę.",
        de: "Ich rufe den Lift.",
      },
      {
        pl: "WC jest obok schodów.",
        de: "Das WC ist neben der Treppe.",
      },
      {
        pl: "Moja babcia ma latem wiele kwiatów na balkonie.",
        de: "Meine Oma hat im Sommer viele Blumen auf dem Balkon.",
      },
      {
        pl: "Lubimy jeść śniadanie na tarasie.",
        de: "Wir frühstücken gern auf der Terrasse.",
      },
      {
        pl: "Samochód stoi na parkingu.",
        de: "Das Auto steht auf dem Parkplatz.",
      },
      {
        pl: "Polska leży w Europie.",
        de: "Polen liegt in Europa.",
      },
      {
        pl: "Kot jest pod stołem.",
        de: "Die Katze ist unter dem Tisch.",
      },
      {
        pl: "Obraz wisi nad łóżkiem.",
        de: "Das Bild hängt über dem Bett.",
      },
      {
        pl: "Portugalia leży obok Hiszpanii.",
        de: "Portugal liegt neben Spanien.",
      },
      {
        pl: "Siedzimy przy stole.",
        de: "Wir sitzen an dem (am) Tisch.",
      },
      {
        pl: "Pochodzę z Polski.",
        de: "Ich komme aus Polen.",
      },
      {
        pl: "Książka leży za tobą.",
        de: "Das Buch liegt hinter dir.",
      },
      {
        pl: "Dzieci bawią się przed domem.",
        de: "Die Kinder spielen vor dem Haus.",
      },
      {
        pl: "On siedzi między nami.",
        de: "Er sitzt zwischen uns.",
      },
      {
        pl: "Czy widziałeś moje okulary? – Tak, leżą tu.",
        de: "Hast du meine Brille gesehen? – Ja, sie liegt hier.",
      },
      {
        pl: "Kim jest ta młoda kobieta tam?",
        de: "Wer ist diese junge Frau dort?",
      },
      {
        pl: "Ty, Brigitte, masz ochotę iść dziś wieczorem do kina?",
        de: "Du, Brigitte, hast du Lust, heute Abend ins Kino zu gehen?",
      },
      {
        pl: "Tak, dobry pomysł. Gdzie się spotkamy?",
        de: "Ja, gute Idee. Wo treffen wir uns?",
      },
      {
        pl: "Przykro mi, ale niestety nie mam czasu!",
        de: "Tut mir Leid, aber ich habe leider keine Zeit!",
      },
      {
        pl: "Czy Brigitte ma ochotę iść do kina?",
        de: "Hat Brigitte Lust, ins Kino zu gehen?",
      },
      {
        pl: "Tak, ona ma ochotę i czas",
        de: "Ja, sie hat Lust und Zeit",
      },
      {
        pl: "Tak, ale ona nie ma czasu",
        de: "Ja, aber sie hat keine Zeit",
      },
      {
        pl: "Masz ochotę iść do parku?",
        de: "Hast du Lust, in den Park zu gehen?",
      },
      {
        pl: "Masz ochotę iść do miasta?",
        de: "Hast du Lust, in die Stadt zu gehen?",
      },
      {
        pl: "Masz ochotę iść do lodziarni?",
        de: "Hast du Lust, in die Eisdiele zu gehen?",
      },
      {
        pl: "Masz ochotę iść do pizzerii?",
        de: "Hast du Lust, in die Pizzeria zu gehen?",
      },
      {
        pl: "Masz ochotę iść do domu towarowego?",
        de: "Hast du Lust, ins Kaufhaus zu gehen?",
      },
      {
        pl: "Masz ochotę iść do restauracji?",
        de: "Hast du Lust, ins Restaurant zu gehen?",
      },
      {
        pl: "Gdzie można biegać?",
        de: "Wo kann man joggen?",
      },
      {
        pl: "Gdzie można jeść i pić?",
        de: "Wo kann man essen und trinken?",
      },
      {
        pl: "Gdzie można kupić buty?",
        de: "Wo kann man Schuhe kaufen?",
      },
      {
        pl: "Gdzie można oglądać filmy?",
        de: "Wo kann man Filme sehen?",
      },
      {
        pl: "Gdzie można spotkać ludzi?",
        de: "Wo kann man Leute treffen?",
      },
      {
        pl: "Gdzie można tańczyć?",
        de: "Wo kann man tanzen?",
      },
      {
        pl: "Gdzie można jeść pizzę?",
        de: "Wo kann man Pizza essen?",
      },
      {
        pl: "Gdzie można jeść lody?",
        de: "Wo kann man Eis essen?",
      },
      {
        pl: "Gdzie można wypłacić/wymienić pieniądze?",
        de: "Wo kann man Geld abheben / wechseln?",
      },
      {
        pl: "Gdzie można kupić lekarstwa?",
        de: "Wo kann man Medikamente kaufen?",
      },
      {
        pl: "Gdzie można pić kawę?",
        de: "Wo kann man Kaffee trinken?",
      },
      {
        pl: "Gdzie można kupić znaczki pocztowe?",
        de: "Wo kann man Briefmarken kaufen?",
      },
      {
        pl: "Gdzie można spacerować?",
        de: "Wo kann man spazieren gehen?",
      },
      {
        pl: "Gdzie można uczyć się języków obcych?",
        de: "Wo kann man Fremdsprachen lernen?",
      },
      {
        pl: "Przepraszam, jak dojdę do kina Astra?",
        de: "Entschuldigung, wie komme ich zum Astra-Kino?",
      },
      {
        pl: "Zawsze prosto aż do placu Stephansplatz, potem w lewo.",
        de: "Immer geradeaus bis zum Stephansplatz, dann links.",
      },
      {
        pl: "Nie, nie. Idziesz prosto aż do skrzyżowania, a potem w prawo",
        de: "Nein, nein. Du gehst geradeaus bis zur Kreuzung und dann rechts",
      },
      {
        pl: "Najlepiej pojedziesz autobusem numer 12",
        de: "Du fährst am besten mit dem Bus Nr. 12",
      },
      {
        pl: "Masz ochotę iść do kina?",
        de: "Hast du Lust, ins Kino zu gehen?",
      },
    ],
  },
];

const ZDANIA38 = [
  {
    name: "[6 klasa] Mod 6. Kap 2. - str 56",
    lang: 'de',
    zdania: [
      {
        pl: "pokój",
        de: "das Zimmer",
      },
      {
        pl: "To jest pokój Karin",
        de: "Das ist das Zimmer von Karin",
      },
      {
        pl: "sufit",
        de: "die Decke",
      },
      {
        pl: "Lampa wisi na suficie",
        de: "Die Lampe hängt an der Decke",
      },
      {
        pl: "ściana",
        de: "die Wand",
      },
      {
        pl: "Ściana jest niebieska",
        de: "Die Wand ist blau",
      },
      {
        pl: "podłoga",
        de: "der Boden",
      },
      {
        pl: "Dywan leży na podłodze",
        de: "Der Teppich liegt auf dem Boden",
      },
      {
        pl: "okno",
        de: "das Fenster",
      },
      {
        pl: "W oknie stoją kwiaty",
        de: "Im Fenster stehen Blumen",
      },
      {
        pl: "drzwi",
        de: "die Tür",
      },
      {
        pl: "Te drzwi są z drewna",
        de: "Die Tür ist aus Holz",
      },
      {
        pl: "otwierać",
        de: "aufmachen",
      },
      {
        pl: "Otwórz drzwi!",
        de: "Mach die Tür auf!",
      },
      {
        pl: "zamykać",
        de: "zumachen",
      },
      {
        pl: "Zamknę okno",
        de: "Ich mache das Fenster zu",
      },
      {
        pl: "wejście",
        de: "der Eingang",
      },
      {
        pl: "Tutaj jest wejście",
        de: "Hier ist der Eingang",
      },
      {
        pl: "wyjście",
        de: "der Ausgang",
      },
      {
        pl: "Gdzie jest wyjście?",
        de: "Wo ist der Ausgang?",
      },
      {
        pl: "dywan",
        de: "der Teppich",
      },
      {
        pl: "Ten dywan jest bardzo stary",
        de: "Dieser Teppich ist sehr alt",
      },

      {
        pl: "prosto",
        de: "geradeaus",
      },
      {
        pl: "Idź prosto",
        de: "Gehen Sie geradeaus",
      },
      {
        pl: "w prawo",
        de: "nach rechts",
      },
      {
        pl: "Skręć w pierwszą ulicę w prawo",
        de: "Nehmen Sie die erste Straße rechts",
      },
      {
        pl: "w lewo",
        de: "nach links",
      },
      {
        pl: "Skręć w pierwszą ulicę w lewo",
        de: "Nehmen Sie die erste Straße links",
      },

      {
        pl: "Przejdź obok kościoła",
        de: "Gehen Sie an der Kirche vorbei",
      },
      {
        pl: "Kino znajduje się na rogu",
        de: "Das Kino befindet sich an der Ecke",
      },
      {
        pl: "Sklep z kwiatami jest naprzeciwko parku",
        de: "Der Blumenladen ist gegenüber dem Park",
      },
      {
        pl: "Na rondzie skręć w prawo",
        de: "Im Kreisverkehr nehmen Sie die erste Straße rechts",
      },
      {
        pl: "Na światłach skręć w lewo",
        de: "An der Ampel nehmen Sie die erste Straße links",
      },
      {
        pl: "Na skrzyżowaniu idź prosto",
        de: "An der Kreuzung gehen Sie geradeaus",
      },
      {
        pl: "Plac Stefana znajduje się za kinem",
        de: "Der Stephanplatz befindet sich hinter dem Kino",
      },
      {
        pl: "Przepraszam, jak dojdę do Banku?",
        de: "Entschuldigung, wie komme ich zur Bank?",
      },
      {
        pl: "Przepraszam, jak dojdę do muzeum miejskiego?",
        de: "Entschuldigung, wie komme ich zum Stadtmuseum?",
      },
      {
        pl: "Przepraszam, jak dojdę do kawiaciarni?",
        de: "Entschuldigung, wie komme ich zum Blumenladen?",
      },
      {
        pl: "Idź prosto aż do skrzyżowania, potem w lewo",
        de: "Gehen Sie geradeaus bis zur Kreuzung, dann links",
      },
      {
        pl: "Idź prosto do świateł, potem w prawo",
        de: "Gehen Sie geradeaus bis zur Ampel, dann rechts",
      },
      {
        pl: "Idź prosto do muzeum, potem w lewo",
        de: "Gehen Sie geradeaus bis zum Museum, dann links",
      },
      {
        pl: "Idź koło kościoła, potem w prawo",
        de: "Gehen Sie an der Kirche vorbei, dann rechts",
      },
      {
        pl: "Idz kolo Kina, potem w lewo",
        de: "Gehen Sie am Kino vorbei, dann links",
      },
      {
        pl: "Jak dojdę do Dworca kolejowego?",
        de: "Wie komme ich zum Bahnhof?",
      },
      {
        pl: "Jak dojdę do Uniwersytetu?",
        de: "Wie komme ich zur Universität?",
      },
      {
        pl: "Jak dojdę do stadionu?",
        de: "Wie komme ich zum Stadion?",
      },
      {
        pl: "Najlepiej autobusem",
        de: "Am besten mit dem Bus",
      },
      {
        pl: "Najlepiej tramwajem",
        de: "Am besten mit der Straßenbahn",
      },
      {
        pl: "Najlepiej metrem",
        de: "Am besten mit der U-Bahn",
      },
      {
        pl: "Najepiej taksówką",
        de: "Am besten mit dem Taxi",
      },
    ],
  },
];

export { ZDANIA36, ZDANIA37, ZDANIA38 };
